/**
 * 郵便番号チェック
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/jipcode`

const search_jipcode = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     *
     * @param commit
     * @param params
     * @property zip_code { string } 排出事業者 郵便番号
     * @property address_1 { string } 排出事業者 住所1
     * @property prefecture_code { string } 排出事業者 都道府県コード
     * @property location_zip_code { string} 排出事業場 郵便番号
     * @property location_prefecture_code { string } 排出事業場 都道府県コード
     * @property location_address_1 { string } 排出事業場 住所1
     * @return {Promise<unknown>}
     * @return {Promise<unknown>}
     */
    show ({ commit }, { params }) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}
export default search_jipcode
